import React, { useEffect, useState, useRef } from "react";
import { Card, Row, Col, Overlay, Tooltip, OverlayTrigger, Button, Image, Table } from 'react-bootstrap';
import moment from 'moment';
import Filedownload from 'js-file-download';
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import ReplyMessage from "./ReplyMessage";
import MessageReply from "./MessageReply";
import DOMPurify from "dompurify";
import { BsReplyFill, BsCaretDownFill, BsInfoCircleFill} from "react-icons/bs";
import userImage from "../assets/user.png" 
import ApiService from "../ApiService";
import { getSenderName, getSenderInitial } from "../util/common";
import { getUserRoles, ROLE_NAME } from "../util/authUtil";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
} 

const MessageText = (props) => {
    const { messageUUID, message, sentMessage } = props;
    const parentUUID = message.messageParentUUID;
    const [replyMessageComponent, setReplyMessageComponent] = useState(null);
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackSeverity, setSnackSeverity] = useState("");
    const [snackText, setSnackText] = useState("");
    const [patientDetail, setPatientDetail] = useState(null)



    useEffect(() => {
        const userSubId =
          message?.fromField === "PATIENT"
            ? message?.fromId
            : message?.toField === "PATIENT"
            ? message?.toUsers.find(user => user.addresseeType === "PATIENT")?.userId
            : message?.toIds[0];
    
        if (userSubId && message?.messageType !== "BELUGA") {
          ApiService.getPatientDetailsBySubId(userSubId)
            .then(res => {
              if (res?.data) setPatientDetail(res.data);
            })
            .catch(err => {
              console.error(err);
            });
        }
    }, [message]);
    
      const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    
      useEffect(() => {
        getUserRoles().then(roles => {
            setIsSuperAdmin(roles.includes(ROLE_NAME.SUPER_ADMIN));
        });
      }, [])

    const handleSnackOpen = (text, severity) => {
        setSnackSeverity(severity);
        setSnackText(text);
        setSnackOpen(true);
    };

    const handleSnackClose = () => {
        setSnackOpen(false);
    };


    function reply() {
        setReplyMessageComponent(<ReplyMessage messageUUID={messageUUID} />);
    }

    useEffect(() => {
        if (!message.fromId && document.getElementById("msg_reply")) {
            document.getElementById("msg_reply").style.display = "none";
        } else if (document.getElementById("msg_reply")) {
            document.getElementById("msg_reply").style.display = "block";
        }
    }, [message.fromId])

    const download = async (fileName) => {
        if (!fileName) {
            return;
        }
        await ApiService.downloadFile('MESSAGE_ATTACHMENTS', fileName)
            .then(resp => {
                Filedownload(resp.data, fileName.substring(fileName.indexOf('_') + 1));
            })
            .catch(async (error) => {
                const data = error?.response?.data;
                if (
                    error?.request?.responseType === 'blob' &&
                    data instanceof Blob &&
                    data?.type &&
                    data.type.toLowerCase().indexOf('json') != -1
                ) {
                    const errorString = JSON.parse(await data?.text());
                    handleSnackOpen(errorString?.reason, "error");
                }
            });
    };

    if (!message) {
        return (<div className="open_message load_message"><i class="fas fa-spinner fa-pulse"></i></div>)
    } else {
        return (
            <div className="divRow">
                    <Card.Title as={Row} className="msgSubject">
                        <Col>SUB: {message.subject}</Col>
                        <Col className="titleInfo">{message.ccOnly === true? 
                            <OverlayTrigger
                                    placement="bottom"
                                    overlay={
                                    <Tooltip>
                                        <Row className="tooltipCard">
                                            You are in CC with this message thread.
                                        </Row>
                                    </Tooltip>
                                    }
                                >
                                    <Button variant="warning" size="sm" id="ccToBtn">CC <BsInfoCircleFill/></Button>
                                </OverlayTrigger> : <OverlayTrigger
                                    placement="bottom"
                                    overlay={
                                    <Tooltip>
                                        <Row className="tooltipCard">
                                            This message is sent to you. {message?.toNames?.toString()}
                                        </Row>
                                    </Tooltip>
                                    }
                                >
                                    <Button variant="warning" size="sm" id="ccToBtn">To <BsInfoCircleFill/></Button>
                            </OverlayTrigger>}
                        </Col>
                    </Card.Title>
                    <Card.Text>
                        <Row className="msgFromUser">
                            <div className="msgFromUserBig"><OverlayTrigger
                                    placement="bottom"
                                    overlay={
                                    <Tooltip className="profileTooltip">
                                        <Row className="profileCard">
                                            <Col md={3}>
                                                <div>
                                                {
                                                    <Image roundedCircle className="profile-pic" alt={"TBD user "} src={userImage}/>
                                                }
                                                </div>
                                            </Col>
                                            <Col md={8}>
                                                    <div className="userName">
                                                        {getSenderName(message, patientDetail)}                                                            
                                                </div>
                                                <div>
                                                    {message?.fromUser?.phoneNumber}
                                                </div>
                                                <div>
                                                    {message?.fromUser?.email}
                                                </div>
                                            </Col>
                                        </Row> 
                                    </Tooltip>
                                    }
                                >
                            <div>
                            {getSenderInitial(message, patientDetail)}                                                            
                            </div>
                                </OverlayTrigger>
                            </div>
                            <Col md={7}>
                                <p className="msgFromUserFull">{getSenderName(message, patientDetail)}</p>
                                <p className="msgToUser">To: {(message?.toNames?.toString() || '').substring(0, 50)}... <span ref={target} onClick={() => setShow(!show)}> <BsCaretDownFill/></span></p>
                                <p className="msgToUser">CC: {(message?.ccToGroupNames?.toString() || '').substring(0, 50)}</p>
                            </Col>
                            <Col className="text-right" md={4}>
                                {
                                (sentMessage !== true && message.fromID !== null) || message.reply === true || isSuperAdmin ?
                                    <p className="mssReplySmall" onClick={reply}>Reply <BsReplyFill/></p>
                                    : <OverlayTrigger
                                        placement="left"
                                        overlay={
                                        <Tooltip>
                                            <Row className="tooltipCard">
                                                You have Read Only access to this message thread.
                                            </Row>
                                        </Tooltip>
                                        }
                                    >
                                        <Button variant="secondary" size="sm" id="readOnlyBtn">Read only <BsInfoCircleFill/></Button>
                                    </OverlayTrigger>
                                }
                                <p className="msgToUser">{moment(message.createdDateTime).format("ddd MMM D, YYYY LT")}</p>
                            </Col>
                        </Row>
                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message.content) }}
                            className="message_text">
                        </div>
                        {message?.attachmentUrls?.length > 0 ? (
                            <div>
                                {message.attachmentUrls.map((item) => (
                                    <div className="attachment-files" onClick={() => download(item)}>
                                        <div className="file-name-text">
                                            {(item && item.indexOf('_') !== -1) ? item.substring(item.indexOf('_') + 1) : item}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : null}
                        {replyMessageComponent}
                    </Card.Text>
                    <hr></hr>
                    <Overlay target={target.current} show={show} placement="right">
                        {(props) => (
                        <Tooltip {...props}>
                            <Row className="overlayCard">
                            <Table size="sm" className="tooltipTable">
                                <tbody>
                                    <tr className="tabRow">
                                        <td className="colText">
                                            From:
                                        </td>
                                        <td className="colText">
                                            {message?.fromUser?.firstName} {message?.fromUser?.lastName}
                                        </td>
                                    </tr>
                                    <tr className="tabRow">
                                        <td className="colText">
                                            To:
                                        </td>
                                        <td className="colText">
                                            {message?.toNames?.toString()}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            </Row>
                        </Tooltip>
                        )}
                    </Overlay>
                    {/* code made hiddden for later use / backup */}

                    <MessageReply message={message} messageUUID={parentUUID} />
                    <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                        <Alert onClose={handleSnackClose} severity={snackSeverity}>
                            {snackText}
                        </Alert>
                    </Snackbar>
            </div>
        )
    }
}

export default MessageText;